<template>
  <section class="hbox stretch">
    <div class="content-header">      
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
        <el-breadcrumb-item>计次管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true" size="medium">            
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="Add" >新增</el-button>
        </el-form-item>
        <el-form-item >
          <el-input  placeholder="名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="rows" style="width: 100%">
        <el-table-column  fixed  prop="Title"  label="标题" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column  fixed  prop="BusinessName"  label="所属商家" > </el-table-column>
        <el-table-column  fixed  prop="Count"  label="数量" width="70px"> </el-table-column>
        <el-table-column  fixed  prop="OriginalPrice"  label="原价" width="70px"> </el-table-column>
        <el-table-column  fixed  prop="Price"  label="售价" width="70px"> </el-table-column>
        <el-table-column  fixed  prop="LimitCount"  label="每人限购" > </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="Edit(scope.row)" type="text" size="small">
            编辑
          </el-button>
          <el-button @click.native.prevent="deleteRow(scope.row.Id)" type="text" size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <dia v-bind:dialog="dialog" ></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:0,
        sort:'Id desc',
        rows:[],
        dialog: {
          id:'0',
          title: '',
          isShow:false
        }
      }
    },
    components:{    
      dia
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/MeasuredService/index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      Add:function(){
        this.dialog.id = '0'
        this.dialog.title = '新增次卡'
        this.dialog.isShow = true
      },
      Edit(row){
        this.dialog.id = row.Id
        this.dialog.title = '编辑次卡'
        this.dialog.isShow = true 
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },      
      deleteRow(id) {
        this.$confirm('确定要删除该产品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/MeasuredService/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>